var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('footer',[_c('span',[_c('a',{attrs:{"href":_vm.projectUrl}},[_vm._v("LaoWang Nav")]),_vm._v(" is a personal dashboard. © "),_c('a',{attrs:{"href":_vm.authorUrl}},[_vm._v(_vm._s(_vm.authorName))]),_vm._v(" "+_vm._s(_vm.currentYear)+". ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }